import { Component } from '@angular/core';
import { ModalComponent } from '../../../../../models/modal-component';

@Component({
    selector: 'app-redirect-modal',
    templateUrl: './redirect-modal.component.html',
    styleUrls: ['./redirect-modal.component.scss']
})

export class RedirectModalComponent extends ModalComponent {
    static MODAL_ID = 'redirectModal';

    getId(): string {
        return RedirectModalComponent.MODAL_ID;
    }

    close(): void {
        $('html')
            .css('cursor', 'initial');
    }
}
